import { Card } from '@app/components/various/Card';
import { Status } from '@app/components/various/Status';
import { getCalculatedInvoiceStatus } from '@app/logic/invoices';
import { getInvoiceStatusColor } from '@app/utils/status';
import { ColumnsConfiguration, Invoice } from '@typings';
import { useTranslation } from 'react-i18next';

import { InvoiceStatusLabel } from '../InvoiceStatusLabel';

interface Props {
  invoice: Invoice.Base;
  columnsVisibility: ColumnsConfiguration;
}

export const BaseInvoiceCard = ({ invoice, columnsVisibility }: Props) => {
  const { t } = useTranslation(['common']);
  const { createdAt, dueDate, invoiceNumber } = invoice;
  const status = getCalculatedInvoiceStatus(invoice);

  return (
    <Card.Wrapper markerColor={getInvoiceStatusColor(status)}>
      {columnsVisibility.status?.isVisible && (
        <Card.Header>
          <Status type={status} />
          <span>
            {t('common:status')}:{' '}
            <span className="text-neutral-20">
              <InvoiceStatusLabel status={status} />
            </span>
          </span>
        </Card.Header>
      )}
      <Card.Title>#{invoiceNumber}</Card.Title>
      <Card.AttributeList>
        {columnsVisibility.createdAt?.isVisible && <Card.Attribute name={t('common:created')} value={createdAt}></Card.Attribute>}
        {columnsVisibility.dueDate?.isVisible && <Card.Attribute name={t('common:due_date')} value={dueDate}></Card.Attribute>}
      </Card.AttributeList>
    </Card.Wrapper>
  );
};
